//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vFilter from "../util/filters"
    export default {
        name: 'loan-info',
        props: {
            detailObj: {
                type: Object,
                default: null,
            }
        },
        filters:{
            filterMoney:vFilter.moneyFormat3
        },
        data () {
            return {
                showDetail: {

                }
            }
        },
        watch: {
            detailObj (val) {
                this.showDetail = val;
            }
        },
        mounted(){
            if (this.detailObj != null && this.detailObj != '') {
                this.showDetail = this.detailObj
            }
        },
        methods: {
            handleClick () {
                this.$emit('t-click', this.showDetail);
            }
        }

    }



// WEBPACK FOOTER //
// ./src/components/LoanInfo.vue